/* eslint-disable */
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { TProductForm, TProductParams } from "@/features/products/create/types";
import { useTranslation } from "react-i18next";

import { makeRequired, makeValidate, SelectData } from "mui-rff";
import { schema } from "@/features/products/create/validations";
import { makeYupTranslatedError } from "@/helpers/yup";
import ProductForm from "@/features/products/create/components/form";
import { AxiosRequestConfig, AxiosResponse } from "axios";
// helpers to concat select data
import { concatSelectData, transformCatalog, transformCatalogKey, transformCatalogMultiple } from '@/helpers/generic-transformer';
// lodash get to execute promise
import { toastError, toastSuccess } from "@/helpers/toast";
import { getProduct, getTaxesData, getTUnitData, saveProduct } from "@/apis/product";
import lGet from "lodash/get";
import { convertJSONToString, errorMessageFromServer } from "@/utils/server";
import BackDrop from "@/components/backdrop/BackDrop";
import { getDecimalValue } from "@/helpers/deicmal-calculus";
import _ from "lodash";
import { useSelector } from "react-redux";
import { selectIsRegisterCompleted } from "@/store/slices/authSlice";
import { goURL } from "@/helpers/router";
import { checkErrorResponse } from "@/helpers/axios";
import Paper from '@mui/material/Paper';
import { Box, Grid } from "@mui/material";
import {useCurrentPath} from "@/hooks/useCurrentPath";
import SimpleSpinner from "@/components/spinner/simpleSpinner";

const CreateProduct = ({ isModal, callback, id, icon, callbackList, isModalInvoice, isHeaderBtn, from = "route" }: any): any => {
    //console.log('@CreateProduct loading component from ', from);

    const path: any =  useCurrentPath();
    const modalHeaderCallback = () => {
       console.log('modalHeaderCallback path', path);
        console.log('modalHeaderCallback path typeof', typeof path);
        if (path === '/list/product') {
            console.log('reload path product list');
            history.go(0)
        }
    }

    // obtener si ya completó registro
    const register_complete: boolean = useSelector(selectIsRegisterCompleted);

    // for redirect if edition is from full page
    const history = useHistory();

    // check if product id is on url
    const { product_id }: TProductParams = useParams<TProductParams>();

    // set productId if exists
    const productId = isModal ? (id || null) : (product_id || null);

    // translations
    const [t] = useTranslation();

    // backdrop loader
    const [loading, setLoading] = useState(true);

    // to know if modal is open
    const [modalOpen, setModalOpen] = useState(false);

    const [loadedData, setLoadedData] = useState(false);

    // submit
    const [submitting, setSubmitting] = useState(false);

    // initial values
    const initialValues: any = {
        productos_tipo: '0',
        productos_claveprodserv: '',
        productos_descripcion: '',
        productos_numero_identificacion: '',
        productos_cat_units_id: 1,
        productos_valor: '0',
        productos_precio_unitario: '',
        productos_cat_taxobject_id: 2,
        productos_cat_vat_taxes_id: 1,
        productos_cat_vat_rates_id: 1,
        productos_r_isr: '',
        productos_ieps: ''
    };
    const initialValuesRef = useRef<any>(initialValues);

    // product type
    const selectDataProductType: any[] = [
        { label: t('product.label_product'), value: '0' },
        { label: t('product.label_service'), value: '1' },
    ];

    // price type
    const selectDataPriceType: any[] = [
        { label: t('product.label_unit_price'), value: '0' },
        { label: t('product.label_total_import'), value: '1' },
    ];

    // units
    const selectDataUnit: SelectData[] = [];
    const selectDataUnitsRef = useRef<SelectData[]>(selectDataUnit);

    // tax object
    const selectDataTaxObject: SelectData[] = [];
    const selectTaxObjectRef = useRef<SelectData[]>(selectDataTaxObject);
    const [checkedTax, setCheckedTax] = React.useState(true);
    const handleChangeTax = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.checked;
        setCheckedTax(value);
    };

    // iva
    const selectDataIVA: SelectData[] = [];
    const selectDataIVARef = useRef<SelectData[]>(selectDataIVA);

    // ret iva
    const selectDataIVAWithHolding: SelectData[] = [];
    const selectDataIVAWithHoldingRef = useRef<SelectData[]>(selectDataIVAWithHolding);

    const getData = useCallback(async () => {
        // set loader
        setLoading(true);

        try {
            // only get product when id exists
            if (productId) {
                // params request
                const config: AxiosRequestConfig = {
                    params: {
                        id: productId
                    }
                }

                // request API
                const response: AxiosResponse = await getProduct(config);

                // product
                const product: object = response.data.product_data;

                await formatProductData(product);
            }

            // get units catalog
            const promiseUnitData = getTUnitData();
            const resultsUnitsTaxes = await Promise.all<Promise<AxiosResponse>>([promiseUnitData]);

            // set catalog units
            const units_select_data: SelectData[] = transformCatalogMultiple(resultsUnitsTaxes[0].data.units, 'key', 'name', 'id');
            selectDataUnitsRef.current = concatSelectData(selectDataUnitsRef.current, units_select_data);

            // set catalog tax object
            const taxobject_select_data: SelectData[] = transformCatalogKey(resultsUnitsTaxes[0].data.taxobjects, 'descripcion', 'id', 'clave');
            selectTaxObjectRef.current = concatSelectData(selectTaxObjectRef.current, taxobject_select_data);

            // get taxes catalogs
            const promiseTaxesData = getTaxesData();
            const resultsTaxes = await Promise.all<Promise<AxiosResponse>>([promiseTaxesData]);

            // set catalog taxes
            const user_tax_data = resultsTaxes[0].data.user_taxes_data;
            initialValuesRef.current = { ...initialValuesRef.current, ...user_tax_data };

            // set catalog taxes
            const taxvat_select_data: SelectData[] = transformCatalog(resultsTaxes[0].data.tax_vat, 'name', 'id');
            selectDataIVARef.current = concatSelectData(selectDataIVARef.current, taxvat_select_data);

            // set catalog retentions
            const taxvatrates_select_data: SelectData[] = transformCatalog(resultsTaxes[0].data.tax_vat_rates, 'name', 'id');
            selectDataIVAWithHoldingRef.current = concatSelectData(selectDataIVAWithHoldingRef.current, taxvatrates_select_data);

            // default impuestos que aplican
            if (!productId) {
                const product: any = resultsTaxes[0].data.user_taxes_data;

                await formatBasicCreateData(product);
            }

            // to know if data was loaded on first load
            setLoadedData(true);
        } catch (e) {
            // Call general error
            toastError('Ocurrió un error al cargar los datos');
            checkErrorResponse(e);
        } finally {
            // stop loading
            setLoading(false);
        }
    }, []);

    // decimal values
    const calculateDecimal = (value: any): number => {
        let decimalValue = getDecimalValue(`0`);
        if (value) {
            decimalValue = getDecimalValue(`${value}`);
        }
        return decimalValue.toNumber();
    }

    // to read "impuestos que aplican"
    const formatBasicCreateData = (product: any) => {
        // recalculate isr
        const r_isr = calculateDecimal(product?.r_isr);

        // recalculate ieps
        const ieps = calculateDecimal(product?.ieps);

        initialValuesRef.current = {
            ...initialValuesRef.current,
            productos_cat_vat_taxes_id: product?.cat_vat_taxes_id || initialValuesRef.current.productos_cat_vat_taxes_id,
            productos_cat_vat_rates_id: product?.cat_vat_rates_id || initialValuesRef.current.productos_cat_vat_rates_id,
            productos_r_isr: (r_isr > 0) ? r_isr : '',
            productos_ieps: (ieps > 0) ? ieps : ''
        };
    }

    // format customer data to initial values
    const formatProductData = async (product: any) => {
        // recalculate isr
        const r_isr = calculateDecimal(product?.r_isr);

        // recalculate ieps
        const ieps = calculateDecimal(product?.ieps);

        // 1 importe total, 0 precio unitario
        const valor: number = product.valor;

        initialValuesRef.current = {
            productos_tipo: `${product.tipo}`,
            productos_claveprodserv: product.claveprodserv,
            productos_descripcion: product.descripcion,
            productos_numero_identificacion: product?.numero_identificacion || '',
            productos_cat_units_id: product.unit.id,
            productos_valor: `${product.valor}`,
            productos_precio_unitario: (valor >= 1) ? product.importe : product.precio_unitario,
            productos_cat_taxobject_id: product.tax_object.id,
            productos_cat_vat_taxes_id: product.vat_tax.id,
            productos_cat_vat_rates_id: product.vat_rates.id,
            productos_r_isr: (r_isr > 0) ? r_isr : '',
            productos_ieps: (ieps > 0) ? ieps : ''
        };

        if (product.tax_object.clave === "01") {
            setCheckedTax(false);
        }
    }

    const searchTaxObjectKey = (clave: string, data: SelectData[]) => {
        //console.log(data);
        const objectTax: any = _.find(data, (d: any) => d.label.includes(clave));
        //console.log(objectTax);
        if (!objectTax) return;
        return objectTax.value;
    }

    const searchTaxObject = (value: boolean, data: SelectData[]) => {
        return searchTaxObjectKey(value ? "02" : "01", data)
    }

    // mount
    useEffect(() => {
        //console.log("@CreateProduct mount");
        //if (!register_complete) {
        //    goURL('/complete/register/Y29tcGxldGUgcmVnaXN0ZXIK');
        //} else {
            //getData().catch((e: any) => console.error(e));
        //}
        if (!isModal && !isModalInvoice) {
            //console.log("cargar datos porque no es modal");
            getData().catch((e: any) => console.error(e));
        } else {
            //console.log("cargar datos hasta que abra modal");
        }
    }, [])

    useEffect(() => {
        //console.log("@CreateProduct sensing value modalOpen: ", modalOpen);
        if (modalOpen && !loadedData) {
            //console.log("@CreateProduct modal is open and not loaded data first time");
            getData().catch((e: any) => console.error(e));
        }
    }, [modalOpen])

    // validations
    const validateForm = makeValidate(schema, makeYupTranslatedError);
    const required = makeRequired(schema);

    // yes, this can even be async!
    const onSubmit = async (values: any) => {
        // determina si se resetean en el payload los valores
        const objetoImpuesto: boolean = (checkedTax);

        const payload: any = {
            //'cat_vat_rates_id': (values.productos_cat_taxobject_id !== 1) ? values.cat_vat_rates_id : 1,
            //'cat_vat_taxes_id': (values.productos_cat_taxobject_id !== 1) ? values.cat_vat_taxes_id : 1,
            //'r_isr': (values.productos_cat_taxobject_id !== 1) ? values.r_isr : ''
            //'ieps': (values.productos_cat_taxobject_id !== 1) ? values.ieps : '',
            'productos_tipo': values.productos_tipo,
            'productos_claveprodserv': values.productos_claveprodserv,
            'productos_descripcion': values.productos_descripcion,
            'productos_numero_identificacion': values.productos_numero_identificacion,
            'productos_cat_units_id': values.productos_cat_units_id,
            'productos_cat_taxobject_id': searchTaxObject(objetoImpuesto, selectTaxObjectRef.current),
            'productos_valor': values.productos_valor,
            'productos_precio_unitario': values.productos_precio_unitario,
            'productos_cat_vat_taxes_id': (objetoImpuesto) ? values.productos_cat_vat_taxes_id : 1,
            'productos_cat_vat_rates_id': (objetoImpuesto) ? values.productos_cat_vat_rates_id : 1,
            'productos_ieps': (objetoImpuesto) ? values.productos_ieps : '',
            'productos_r_isr': (objetoImpuesto) ? values.productos_r_isr : '',
        }

        return await submitData(payload);
    };

    const submitData = useCallback(async (payload: any) => {
        // set loaders states
        setSubmitting(true);
        setLoading(true);

        try {
            // attach customer id
            if (productId) {
                payload = {
                    ...payload,
                    productos_id: productId
                }
            }

            console.log(payload)

            // call api
            const response = await saveProduct(payload);

            // success
            const message = response.data.message;
            toastSuccess(message);

            // redirect to list uri if exists param in url
            if (product_id || !isModal) {
                history.push('/list/product')
            }

            // callback from list
            if (callbackList) {
                callbackList();
            }

            // executing callback if exist
            if (callback) {
                callback(response.data.product_data, true);
            }

            // to close modal
            return true;
        } catch (error) {
            // error api custom Request
            if (lGet(error, 'data')) {
                const errors = error.data.errors;
                const message = errorMessageFromServer(convertJSONToString(errors));
                toastError(message);
            } else {
                // another error
                console.error('error: ', error);
                checkErrorResponse(error);
            }

            // don't close modal
            return false;
        } finally {
            // reset loaders states
            setSubmitting(false);
            setLoading(false);
        }
    }, []);

    const onChangeTaxObject = async (event: any) => {
        const value = event.target.value;
        if (value === 1) {
            console.log('resetear campos de taxes si es 1', value);
        }
    }

    // props for forms
    const formProps: TProductForm = {
        onSubmit,
        initialValues: initialValuesRef.current,
        validateForm,
        required,
        submitting,
        selectDataProductType,
        selectDataIVA: selectDataIVARef.current,
        selectDataIVAWithHolding: selectDataIVAWithHoldingRef.current,
        selectDataPriceType,
        selectDataUnit: selectDataUnitsRef.current,
        selectDataTaxObject: selectTaxObjectRef.current,
        isModal,
        icon,
        onChangeTaxObject,
        checkedTax,
        handleChangeTax,
        callback: isHeaderBtn ? modalHeaderCallback : null,
        setModalOpen,
        loading
    };

    // render
    return (
        <>
            {/*{
                (!isModalInvoice && !isModal) && (
                    <BackDrop open={loading} text={t("common.loading")} />
                )
            }*/}

            {
                (!isModalInvoice && !isModal) && (
                    <Paper>

                        <Box sx={{ p: 4 }}>

                            {!loading &&
                                <Grid container>
                                    <ProductForm {...formProps} /> no modal
                                </Grid>
                            }
                            {loading && <SimpleSpinner/>}
                        </Box>

                    </Paper>
                )
            }

            {
                (isModal || isModalInvoice) && (
                    <>
                        <ProductForm {...formProps} />
                    </>
                )
            }
        </>
    );
}

export default CreateProduct
